import type { ValueEvent } from '@adornis/base/utilTypes.js';
import { FormField } from '@adornis/formfield/form-field.js';
import { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

/*
 * @element mentoring-ffm-inline-selection
 */
@customElement('mentoring-ffm-inline-selection')
export class MentoringFfmInlineSelection<T> extends FormField<T> {
  @property({ attribute: false }) selectables?: T[];

  @state() private _translation = new TranslationController(this);

  override render() {
    return html`
      <x-flex space="md">
        ${this.error ? html` <x-text tone="error"> ${this.error} </x-text> ` : nothing}
        <x-radiogroup
          flex
          .value=${this.value.value}
          @value-picked=${(e: ValueEvent<T>) => {
            this.value.next(e.detail.value);
            this.dispatchEvent(new CustomEvent('value-picked', { detail: { value: this.value.value } }));
          }}
        >
          <x-flex horizontal crossaxis-center wrap space="sm">
            ${repeat(
              this.selectables ?? [],
              value => html`
                <x-radiobutton
                  label=${this._translation.translate('enums', value)}
                  selectable=${this._translation.translate(value)}
                ></x-radiobutton>
              `,
            )}
          </x-flex>
        </x-radiogroup>
      </x-flex>
    `;
  }
}
